(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-buy-tiers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mhode-tiers').forEach((root) => {
      const cards = root.querySelectorAll('[data-mhode-tier]');
      const qtyInput = root.querySelector('[data-mhode-tier-qty]');
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.tagName === 'INPUT') return;
          cards.forEach((c) => c.classList.remove('is-selected'));
          card.classList.add('is-selected');
          const radio = card.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          if (qtyInput) qtyInput.value = card.dataset.tierQty || '1';
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-faq-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mhode-faq--accordion').forEach(section => {
      const setHeight = (item, open = false) => {
        const panel = item.querySelector('.mhode-faq__acc-panel');
        panel.style.maxHeight = open ? `${panel.scrollHeight}px` : '0px';
      };
      section.querySelectorAll('.mhode-faq__acc-item').forEach(item => {
        setHeight(item, item.classList.contains('is-open'));
      });
      section.addEventListener('click', e => {
        const btn = e.target.closest('.mhode-faq__acc-trigger');
        if (!btn) return;
        const item = btn.closest('.mhode-faq__acc-item');
        const isOpen = item.classList.contains('is-open');
        section.querySelectorAll('.mhode-faq__acc-item').forEach(el => {
          el.classList.remove('is-open');
          el.querySelector('.mhode-faq__acc-trigger')
            ?.setAttribute('aria-expanded', 'false');
          setHeight(el, false);
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          setHeight(item, true);
        }
      });
    });
    document.querySelectorAll('.mhode-faq__grid').forEach(grid => {
      grid.querySelectorAll('.mhode-faq__cell').forEach(cell => {
        const answer = cell.querySelector('.mhode-faq__a');
        if (cell.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          answer.style.maxHeight = '0px';
        }
      });
      grid.addEventListener('click', e => {
        const question = e.target.closest('.mhode-faq__q');
        if (!question) return;
        const item = question.closest('.mhode-faq__cell');
        const answer = item.querySelector('.mhode-faq__a');
        const isOpen = item.classList.contains('active');
        grid.querySelectorAll('.mhode-faq__cell').forEach(cell => {
          cell.classList.remove('active');
          cell.querySelector('.mhode-faq__a').style.maxHeight = '0px';
        });
        if (!isOpen) {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-help-widget"] && !Shopify.designMode) return;
  try {
    
  class MhodeHelp extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('[data-mhode-help-toggle]');
      const panel = this.querySelector('[data-mhode-help-panel]');
      if (!trigger || !panel) return;
      trigger.addEventListener('click', () => {
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (expanded) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        }
      });
    }
  }
  if (!customElements.get('mhode-help')) customElements.define('mhode-help', MhodeHelp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-hp-product-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {

    function initPd(pd) {
      if (pd._mhPd) return;
      pd._mhPd = true;
      /* ========================= ON / OFF TOGGLE ========================= */
      var toggleBtns = pd.querySelectorAll('[data-pd-tab]');
      var panels = pd.querySelectorAll('[data-pd-panel]');

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.dataset.pdTab;
          toggleBtns.forEach(function (b) {
            b.classList.toggle('is-active', b.dataset.pdTab === target);
          });

          panels.forEach(function (p) {
            p.style.display = p.dataset.pdPanel === target ? '' : 'none';
          });

        });
      });
      /* ========================= ACCORDION ========================= */
      pd.querySelectorAll('.mhode-pd__acc-trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {

          var item = trigger.closest('.mhode-pd__acc-item');
          var body = item.querySelector('.mhode-pd__acc-body');
          var icon = trigger.querySelector('.mhode-pd__acc-icon');

          var isOpen = item.classList.contains('is-open');

          //  close all items first
          document.querySelectorAll('.mhode-pd__acc-item').forEach(function (el) {
            el.classList.remove('is-open');
            var b = el.querySelector('.mhode-pd__acc-body');
            var i = el.querySelector('.mhode-pd__acc-icon');
            if (b) b.style.display = 'none';
            if (i) i.textContent = '+';
            var t = el.querySelector('.mhode-pd__acc-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          });

          // open current only if it was closed
          if (!isOpen) {
            item.classList.add('is-open');
            body.style.display = '';
            if (icon) icon.textContent = '−';
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
      /* ========================= PRICE BLOCK SWITCH (NEW SYSTEM) ========================= */
      pd.querySelectorAll('.price-block').forEach(function (opt) {

        opt.addEventListener('click', function () {

          var wrapper = opt.closest('.mhode-pricing__price-block-wrapper');
          if (!wrapper) return;

          wrapper.querySelectorAll('.price-block').forEach(function (o) {
            o.classList.remove('active');
          });

          opt.classList.add('active');
          var priceType = opt.getAttribute('data-price-type');
          var form = opt.closest('.mhode-pd__panel').querySelector('form');
          if (!form) return;

          var existing = form.querySelector('#SellingPlanInput');

          /* ===================== ONE TIME ===================== */
          if (priceType === 'onetime') {
            if (existing) existing.remove();
          }
          /* ===================== SUBSCRIPTION ===================== */
          if (priceType === 'sub') {
            var planId = opt.getAttribute('data-selling-plan') || '';

            if (!existing) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'selling_plan';
              input.id = 'SellingPlanInput';
              input.value = planId;
              form.appendChild(input);
            } else {
              existing.value = planId;
            }
          }

        });
      });

      /* ========================= DROPDOWN PRICE UPDATE ========================= */
      pd.querySelectorAll('#product-option').forEach(function (select) {

        select.addEventListener('change', function () {
          var wrapper = select.closest('.mhode-pricing__price-block-wrapper');
          if (!wrapper) return;

          var selectedOption = select.options[select.selectedIndex];

          var newPrice = selectedOption.getAttribute('data-price');

          var priceEl = wrapper.querySelectorAll('.mhode-pricing__sub-price');
          if (priceEl && newPrice) {
            priceEl.textContent = newPrice;
          }
        });
      });

      /* ========================= ADD TO CART (optional hook) ========================= */
      pd.querySelectorAll('[data-atc-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof mhAddToCart === 'function') {
            mhAddToCart(btn.dataset.atcVariant, btn);
          }
        });
      });

    }

    function boot() {
      document.querySelectorAll('.mhode-pd').forEach(initPd);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-ingredient-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mhode-it').forEach(section => {
    const tabs = Array.from(section.querySelectorAll('.mhode-it__tab'));
    const panels = Array.from(section.querySelectorAll('.mhode-it__panel'));
    const setActive = (activeTab) => {
      const targetId = activeTab.getAttribute('aria-controls');
      tabs.forEach(tab => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
        tab.style.background = isActive ? tab.dataset.activeBg : tab.dataset.idleBg;
        tab.style.color = isActive ? tab.dataset.activeText : tab.dataset.idleText;
      });
      panels.forEach(panel => {
        panel.classList.toggle('is-active', panel.id === targetId);
      });
    };
    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(tab);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.mhode-pdp2').forEach(function (root) {

    /* ── Gallery: Swiper main + thumbs ── */
    var thumbsEl = root.querySelector('.mhode-thumbs-swiper');
    var mainEl   = root.querySelector('.mhode-main-swiper');

    if (thumbsEl && mainEl && typeof Swiper !== 'undefined') {
      /* Thumbs swiper — vertical on desktop, horizontal on mobile */
      var isDesktop = window.innerWidth >= 900;

      var thumbsSwiperInst = new Swiper(thumbsEl, {
        direction:       isDesktop ? 'vertical' : 'horizontal',
        slidesPerView:   'auto',
        spaceBetween:    isDesktop ? 10 : 4,
        watchSlidesProgress: true,
        freeMode: true,
      });

      /* Main image swiper */
      var mainSwiperInst = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween:  0,
        loop:          false,
        speed:         350,
        grabCursor:    true,
        thumbs: { swiper: thumbsSwiperInst },
        navigation: {
          prevEl: mainEl.querySelector('.mhode-pdp2__main-prev'),
          nextEl: mainEl.querySelector('.mhode-pdp2__main-next'),
        },
        // pagination: {
        //   el:        mainEl.querySelector('.mhode-pdp2__dots'),
        //   clickable: true,
        // },
      });

      /* Re-init thumbs direction on resize */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var nowDesktop = window.innerWidth >= 900;
          if (nowDesktop !== isDesktop) {
            isDesktop = nowDesktop;
            thumbsSwiperInst.changeDirection(isDesktop ? 'vertical' : 'horizontal');
          }
        }, 200);
      });
    }
    /* ---- Tier selection: visual state + variant input + price display ---- */
    var tiersEl      = root.querySelector('[data-pdp2-tiers]');
    var variantInput = root.querySelector('[data-pdp2-variant-input]');
    var priceEl      = root.querySelector('[data-pdp2-price]');

    function updatePrice(priceText) {
      if (!priceEl || !priceText) return;

       var match = priceText.match(/£\d+(?:\.\d{2})?/);
      var cleanPrice = match ? match[0] : priceText;
      var nowEl = priceEl.querySelector('.mhode-pdp2__price-now');
      if (nowEl) nowEl.textContent = cleanPrice;
    }
    function applyTier(tier) {
      if (!tier) return;

      tiersEl.querySelectorAll('.mhode-pdp2__tier').forEach(function (t) {
        t.classList.remove('is-selected');
    });

    tier.classList.add('is-selected');

    var radio = tier.querySelector('.pdp2-tier-radio');
    if (!radio) return;

    radio.checked = true;

    var customVariantId = radio.dataset.tierVariant;
    var defaultVariantId = radio.dataset.defaultVariant;
    var planId = radio.dataset.sellingPlanId;

    var form = root.querySelector('.mhode-pdp2__form');

    /* --------------------------
      Variant logic
    -------------------------- */

    if (variantInput) {
      if (customVariantId && customVariantId !== '') {
        // Bundle block
        variantInput.value = customVariantId;
      } else {
        // Subscription block
        variantInput.value = defaultVariantId;
      }
    }

    /* --------------------------
      Selling plan logic
    -------------------------- */

    if (form) {

      // remove old selling plan input
      form.querySelectorAll('[name="selling_plan"]').forEach(function(el) {
        el.remove();
      });

      // add selling plan only if plan exists
      if (planId && planId !== '' && planId !== 'null') {

        var sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';
        sellingPlanInput.value = planId;

        form.appendChild(sellingPlanInput);
      }
    }

    updatePrice(radio.dataset.tierPrice || null);
  }

  if (tiersEl) {
    tiersEl.querySelectorAll('.mhode-pdp2__tier').forEach(function (tier) {
      tier.addEventListener('click', function () { applyTier(tier); });
    });
    /* On load: sync price + variant from whichever tier is pre-selected */
    var initSelected = tiersEl.querySelector('.mhode-pdp2__tier.is-selected');
    if (initSelected) applyTier(initSelected);
  }

    /* ---- ATC: for bundle tiers redirect instead of adding to cart ---- */
  var form = root.querySelector('.mhode-pdp2__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      var selectedTier = tiersEl && tiersEl.querySelector('.mhode-pdp2__tier.is-selected');
      if (!selectedTier) return;
      var radio = selectedTier.querySelector('.pdp2-tier-radio');
      if (!radio) return;
      var bundleUrl = radio.dataset.tierBundleUrl;
      if (!bundleUrl || bundleUrl === 'null') return;
      e.preventDefault();
      window.location.href = bundleUrl;
    });
  }

    /* ---- Review slider (transform-based, responsive) ---- */
    var reviewsWrapper = root.querySelector('[data-sp-reviews]');
    if (!reviewsWrapper) return;
    var track      = reviewsWrapper.querySelector('[data-sp-track]');
    var slides     = reviewsWrapper.querySelectorAll('.mhode-pdp2__review');
    var total      = slides.length;
    var prevBtn    = root.querySelector('[data-sp-prev]');
    var nextBtn    = root.querySelector('[data-sp-next]');
    var currentIdx = 0;
    var perView    = parseInt(reviewsWrapper.dataset.spPerView || '2', 10);

    function getPerView() {
      return window.innerWidth <= 599 ? 1 : perView;
    }

    function clampIdx(idx) {
      var pv = getPerView();
      var max = Math.max(0, total - pv);
      return Math.min(max, Math.max(0, idx));
    }

    function goTo(idx) {
      currentIdx = clampIdx(idx);
      var pv = getPerView();
      var slideWidthPct = 100 / pv;
      track.style.transform = 'translateX(-' + (currentIdx * slideWidthPct) + '%)';
      if (prevBtn) prevBtn.disabled = (currentIdx === 0);
      if (nextBtn) nextBtn.disabled = (currentIdx >= total - pv);
    }

    /* Set each slide width based on perView */
    function updateSlideWidths() {
      var pv = getPerView();
      slides.forEach(function (s) {
        s.style.flex = '0 0 ' + (100 / pv) + '%';
        s.style.paddingRight = pv > 1 ? '12px' : '0';
      });
      goTo(currentIdx);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIdx + 1); });

    /* Hide nav arrows when only 1 slide fits or total <= perView */
    function updateNavVisibility() {
      var pv = getPerView();
      var show = total > pv;
      if (prevBtn) prevBtn.style.display = show ? '' : 'none';
      if (nextBtn) nextBtn.style.display = show ? '' : 'none';
    }

    /* Autoplay support (reads data attrs set by schema render) */
    var autoplayDelay = parseInt(reviewsWrapper.dataset.spAutoplay || '0', 10);
    if (autoplayDelay > 0 && total > 1) {
      setInterval(function () {
        var pv = getPerView();
        var next = currentIdx + 1;
        if (next > total - pv) next = 0;
        goTo(next);
      }, autoplayDelay);
    }

    window.addEventListener('resize', function () {
      updateSlideWidths();
      updateNavVisibility();
    });

    updateSlideWidths();
    updateNavVisibility();
    goTo(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhode-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cta = document.querySelector('[data-mhode-sticky]');
    if (!cta) return;
    let threshold = 600;
    function check() {
      if (window.scrollY > threshold) cta.classList.add('is-visible');
      else cta.classList.remove('is-visible');
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  } catch(e) { console.error(e); }
})();
})();
